import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions"
import {getDriver, getDrivers} from "../../services/drivers.service";
import { AxiosResponse } from 'axios';

export function* GET_DRIVERS(action: {payload: string, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(getDrivers, action.payload);
        if(response.data){
            yield put({
                type: actions.SET_DRIVERS,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* GET_DRIVER(action: {payload: any, type:string}){
    try{
        const { driverId, workspaceUuid } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getDriver,
          workspaceUuid,
          driverId
        );
        if (response.data){
            yield put({
                type: actions.SET_DRIVER,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_DRIVERS, GET_DRIVERS),
        takeEvery(actions.GET_DRIVER, GET_DRIVER)
    ])
}